<template>
  <div class="bg-white rounded-lg shadow-lg border border-slate-200 w-80 p-3">
    <!-- 分类标签 -->
    <div class="flex items-center gap-1 mb-2 border-b border-slate-100 pb-2">
      <button
        v-for="cat in categories"
        :key="cat.key"
        class="px-2 py-1 text-sm rounded transition-colors cursor-pointer"
        :class="activeCategory === cat.key ? 'bg-primary-50 text-primary-600' : 'text-slate-500 hover:bg-slate-50'"
        @click="activeCategory = cat.key"
      >
        {{ cat.icon }}
      </button>
    </div>

    <!-- 表情网格 -->
    <div class="grid grid-cols-8 gap-0.5 max-h-48 overflow-y-auto">
      <button
        v-for="emoji in currentEmojis"
        :key="emoji"
        class="w-8 h-8 flex items-center justify-center text-lg rounded hover:bg-slate-100 transition-colors cursor-pointer"
        @click="$emit('select', emoji)"
      >
        {{ emoji }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

defineEmits(['select'])

const activeCategory = ref('smileys')

const categories = [
  { key: 'smileys', icon: '😀' },
  { key: 'gestures', icon: '👋' },
  { key: 'hearts', icon: '❤️' },
  { key: 'objects', icon: '📎' },
  { key: 'nature', icon: '🌟' }
]

const emojiData = {
  smileys: [
    '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂',
    '🙂', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗',
    '😋', '😛', '😜', '🤪', '😝', '🤗', '🤭', '🤫',
    '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏', '😒',
    '🙄', '😬', '😮', '😯', '😲', '😳', '🥺', '😢',
    '😭', '😤', '😠', '😡', '🤬', '😈', '💀', '💩'
  ],
  gestures: [
    '👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏',
    '✌️', '🤞', '🫰', '🤟', '🤘', '🤙', '👈', '👉',
    '👆', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛',
    '🤜', '👏', '🙌', '🫶', '👐', '🤲', '🤝', '🙏'
  ],
  hearts: [
    '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍',
    '💔', '❤️‍🔥', '💕', '💞', '💓', '💗', '💖', '💘',
    '💝', '💟', '♥️', '🫶', '😍', '🥰', '😘', '💋'
  ],
  objects: [
    '📎', '📌', '📍', '📝', '✏️', '📁', '📂', '📋',
    '📊', '📈', '📉', '💼', '📧', '📨', '📩', '✉️',
    '📱', '💻', '⌨️', '🖥️', '📷', '🎥', '📹', '🔔',
    '🔑', '🔒', '💡', '⏰', '📅', '📆', '✅', '❌'
  ],
  nature: [
    '🌟', '⭐', '🌙', '☀️', '🌈', '🔥', '💧', '❄️',
    '🌸', '🌺', '🌻', '🌹', '🍀', '🌿', '🎄', '🌴',
    '🐶', '🐱', '🐼', '🐨', '🦋', '🐝', '🌊', '🎉',
    '🎊', '🎁', '🏆', '🥇', '🎯', '💎', '🚀', '💫'
  ]
}

const currentEmojis = computed(() => emojiData[activeCategory.value] || [])
</script>
